import { useMemo, useState } from "react";
import fetchTeamSupporters from "../helpers";
const useGetSupporters = (campaignId, teamName) => {
    const [teamData, setTeamData] = useState({
        id: 0,
        name: "",
        slug: "",
        target: 0,
        logo: "",
        supporters_count: 0,
    });
    useMemo(() => fetchTeamSupporters(campaignId, teamName)
        .then((team) => {
        if (team) {
            setTeamData(team);
        }
    }), [campaignId, teamName]);
    return teamData;
};
export default useGetSupporters;
